import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { useNavigate } from 'react-router-dom';

import { BillingSection } from 'components/DeepSearch/components/AccountPage/sections/BillingSection/BillingSection';
import { LoginInformation } from 'components/DeepSearch/components/AccountPage/sections/LoginInformation/LoginInformation';
import { NeedAssistance } from 'components/DeepSearch/components/AccountPage/sections/NeedAssistance/NeedAssistance';
import { PlanUsage } from 'components/DeepSearch/components/AccountPage/sections/PlanUsage/PlanUsage';
import { ProfileDetails } from 'components/DeepSearch/components/AccountPage/sections/ProfileDetails/ProfileDetails';
import { ChatPageContainerStack } from 'components/DeepSearch/components/components';

interface AccountPageV2Props {
  upgradePath?: string;
}

export const AccountPageV2 = ({ upgradePath }: AccountPageV2Props) => {
  const navigate = useNavigate();
  const onUpgradePlanClick = upgradePath
    ? () => navigate(upgradePath)
    : undefined;

  return (
    <ChatPageContainerStack>
      <Stack
        spacing={3.5}
        padding={2.5}
        paddingTop={1}
        width="100%"
        maxWidth="1100px"
      >
        <Text variant="h1">Account</Text>
        <PlanUsage upgradePath={upgradePath} />
        <ProfileDetails />
        <LoginInformation />
        <BillingSection />
        <NeedAssistance onUpgradePlanClick={onUpgradePlanClick} />
      </Stack>
    </ChatPageContainerStack>
  );
};
